<template>
  <v-app id="inspire">
    <GuestContent />
  </v-app>
</template>

<script lang="ts">
import { defineAsyncComponent, defineComponent } from 'vue';

export default defineComponent({
  name: 'GuestLayout',
  components: {
    GuestContent: defineAsyncComponent(() => import('./GuestContent.vue')),
  },
});
</script>
